var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 419,
    viewBox: "0 0 419 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3441_349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 416,
    height: 416
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.607 1.74309L19.9239 31.899C8.92023 32.8617 0.78042 42.5623 1.74312 53.566L31.899 398.249C32.8617 409.253 42.5624 417.393 53.566 416.43L398.249 386.274C409.253 385.312 417.393 375.611 416.43 364.607L386.274 19.9239C385.312 8.9202 375.611 0.780392 364.607 1.74309Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3441_349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.4 0.886353L10.1314 32.7557C4.53596 33.2452 0.396845 38.1781 0.886379 43.7734L32.7557 408.042C33.2453 413.637 38.1781 417.776 43.7735 417.287L408.042 385.418C413.637 384.928 417.776 379.995 417.287 374.4L385.418 10.1313C384.928 4.53593 379.995 0.396817 374.4 0.886353Z",
    fill: "url(#paint0_linear_3441_349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.306 139.828C115.93 138.898 123.788 129.533 122.859 118.909C121.929 108.286 112.564 100.427 101.941 101.357C91.3171 102.286 83.4585 111.652 84.388 122.275C85.3174 132.899 94.6829 140.757 105.306 139.828Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.959 134.171C180.582 133.242 188.441 123.877 187.511 113.253C186.582 102.63 177.216 94.7711 166.593 95.7005C155.969 96.63 148.111 105.995 149.04 116.619C149.97 127.242 159.335 135.101 169.959 134.171Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.611 128.515C245.234 127.586 253.093 118.22 252.164 107.597C251.234 96.9733 241.869 89.1147 231.245 90.0442C220.622 90.9736 212.763 100.339 213.693 110.963C214.622 121.586 223.988 129.445 234.611 128.515Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.263 122.859C309.887 121.929 317.745 112.564 316.816 101.94C315.886 91.3169 306.521 83.4584 295.898 84.3878C285.274 85.3172 277.416 94.6827 278.345 105.306C279.274 115.93 288.64 123.788 299.263 122.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.963 204.48C121.586 203.551 129.445 194.185 128.515 183.562C127.586 172.939 118.22 165.08 107.597 166.009C96.9733 166.939 89.1148 176.304 90.0442 186.928C90.9736 197.551 100.339 205.41 110.963 204.48Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.615 198.824C186.238 197.894 194.097 188.529 193.167 177.906C192.238 167.282 182.873 159.424 172.249 160.353C161.626 161.282 153.767 170.648 154.697 181.271C155.626 191.895 164.991 199.753 175.615 198.824Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M240.267 193.168C250.891 192.238 258.749 182.873 257.82 172.249C256.89 161.626 247.525 153.767 236.901 154.697C226.278 155.626 218.419 164.992 219.349 175.615C220.278 186.238 229.644 194.097 240.267 193.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.921 187.511C315.544 186.582 323.403 177.216 322.473 166.593C321.544 155.969 312.178 148.111 301.555 149.04C290.931 149.97 283.073 159.335 284.002 169.959C284.932 180.582 294.297 188.441 304.921 187.511Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.619 269.133C127.242 268.203 135.101 258.838 134.171 248.215C133.242 237.591 123.876 229.733 113.253 230.662C102.63 231.591 94.771 240.957 95.7005 251.58C96.6299 262.204 105.995 270.062 116.619 269.133Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.271 263.477C191.895 262.547 199.753 253.182 198.824 242.558C197.894 231.935 188.529 224.076 177.905 225.006C167.282 225.935 159.423 235.3 160.353 245.924C161.282 256.547 170.648 264.406 181.271 263.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.923 257.82C256.547 256.891 264.406 247.525 263.476 236.902C262.547 226.278 253.181 218.42 242.558 219.349C231.934 220.279 224.076 229.644 225.005 240.268C225.935 250.891 235.3 258.75 245.923 257.82Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.577 252.164C321.2 251.234 329.059 241.869 328.129 231.245C327.2 220.622 317.835 212.763 307.211 213.693C296.588 214.622 288.729 223.988 289.658 234.611C290.588 245.235 299.953 253.093 310.577 252.164Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.275 333.785C132.899 332.856 140.757 323.491 139.828 312.867C138.898 302.244 129.533 294.385 118.909 295.315C108.286 296.244 100.427 305.609 101.357 316.233C102.286 326.856 111.652 334.715 122.275 333.785Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.927 328.129C197.551 327.2 205.409 317.834 204.48 307.211C203.551 296.587 194.185 288.729 183.562 289.658C172.938 290.588 165.08 299.953 166.009 310.577C166.938 321.2 176.304 329.059 186.927 328.129Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58 322.473C262.203 321.543 270.062 312.178 269.132 301.554C268.203 290.931 258.837 283.072 248.214 284.002C237.591 284.931 229.732 294.297 230.661 304.92C231.591 315.544 240.956 323.402 251.58 322.473Z",
    fill: "#D3B64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.233 316.816C326.857 315.887 334.715 306.521 333.786 295.898C332.856 285.275 323.491 277.416 312.867 278.345C302.244 279.275 294.385 288.64 295.315 299.264C296.244 309.887 305.61 317.746 316.233 316.816Z",
    fill: "#D3B64D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3441_349",
    x1: 16.837,
    y1: 226.089,
    x2: 388.92,
    y2: 193.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.5b5999ac5c4f51dc0bde3c80c8d87a76.svg";
export { ForwardRef as ReactComponent };